import {
	Component
} from '@angular/core'

@Component({
	selector: 'four-oh-four',
	templateUrl: '../views/four-oh-four.component.html'
})

export class FourOhFourComponent{

}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/four-oh-four.component.ts